export const Names = {
  Auth: {
    SignUpStart: 'web_sign_up_start',
    SignInStart: 'web_sign_in_start',
    BinCheck: 'web_sign_up_bin8_check',
    ApplyForm: 'web_sign_up_apply_form',
    CheckCodeStart: 'web_auth_check_code_start',
    CheckCodeFinish: 'web_auth_check_code_finish',
    Logout: 'web_logout',
  },

  Hotel: {
    Suggest: {
      Start: 'h_web_suggest_start',
      Finish: 'h_web_suggest_finish',
      Select: 'h_web_suggest_select',
    },
    Search: {
      Start: 'h_web_search_start',
      Finish: 'h_web_search_finish',
      HotelCategorySelection: 'survey_hotel_category_selection',
    },
    Offer: {
      SelectHotel: 'h_web_select_hotel',
      OffersStart: 'h_web_get_offers_start',
      OffersFinish: 'h_web_get_offers_finish',
      SelectOffer: 'h_web_choose_offer',
      GuestAdded: 'h_web_choose_offer_guest_added',
      PhoneAdded: 'h_web_choose_offer_phone_added',
      CardAdded: 'h_web_choose_offer_card_added',
    },
    Booking: {
      Start: 'h_web_booking_start',
      Finish: 'h_web_booking_finish',
      PopUpStart: 'h_web_redirect_popup_show',
      PopUpContinue: 'h_web_redirect_popup_continue',
      ThreeDS: {
        Start: 'h_web_booking_3DS_start',
        Finish: 'h_web_booking_3DS_finish',
        Show: 'h_web_booking_start_3ds_show',
      },
      StartCvvVerification: 'h_web_booking_start_cvv_verification',
    },
    Price: {
      Check: 'h_web_price_check',
    },
  },

  Car: {
    Search: {
      Start: 'c_web_search_start',
      Finish: 'c_web_search_finish',
    },
    Offer: {
      Select: 'c_web_select_offer',
    },
    Redirect: {
      Show: 'c_web_redirect_popup_show',
      Continue: 'c_web_redirect_popup_continue',
    },
  },

  Flights: {
    Search: {
      Start: 'f_web_search_start',
      Finish: 'f_web_search_finish',
    },
    Offer: {
      Select: 'f_web_select_offer',
    },
    Redirect: {
      Show: 'f_web_redirect_popup_show',
      Continue: 'f_web_redirect_popup_continue',
    },
  },

  Payment: {
    AddCard: {
      Start: 'payment_card_add_start',
      Finish: 'payment_card_add_finish',
    },
  },

  Integration: {
    AuthLink: 'web_auth_link',
    Typeform: 'survey_my_travel_profile',
  },

  // @deprecated
  // Suggest: {
  //   Start: 'h_web_suggest_start',
  //   Finish: 'h_web_suggest_finish',
  //   Select: 'h_web_suggest_select',
  // },
  // Search: {
  //   Start: 'h_web_search_start',
  //   Finish: 'h_web_search_finish',
  //   Select: 'h_web_select_hotel',
  // },
  // Offers: {
  //   Start: 'h_web_get_offers_start',
  //   Finish: 'h_web_get_offers_finish'
  // },
  // Plans: {
  //   Shown: 'h_web_plan_options_shown',
  //   Selected: 'h_web_plan_options_selected',
  // },

  // Policy: {
  //   Start: 'h_web_get_room_policy_start',
  //   Finish: 'h_web_get_room_policy_finish',
  // },
  // Guest: {
  //   Add: 'h_web_add_guest',
  //   Select: 'h_web_select_guest',
  // },
  // Card: {
  //   Add: 'h_web_add_card',
  //   Select: 'h_web_select_card',
  // },
  // Booking: {
  //   Start: 'h_web_booking_start',
  //   Finish: 'h_web_booking_finish',
  //   Error: 'h_web_error_booking'
  // },
  // Page: {
  //   Landed: 'h_web_landed',
  // },
};
